
class Config {
    static base = process.env.REACT_APP_BASE_PATH;
    static host = process.env.REACT_APP_HOST;
    static mainHost = process.env.REACT_APP_MAIN_HOST;
    static backendHost = process.env.REACT_APP_BACKEND_HOST;

    static dateFormat = 'DD/MM/YYYY';
    static dateFormatHour = 'DD/MM/YYYY HH:ii';

    static contactEmail = 'sayhello@swonkie.com';
    static contactAddress = 'Rua do Progresso nº 140';
    static contactLocation = 'Vila Nova de Famalicão, Portugal';
}

export default Config;